import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import type { InputSwitchChangeEvent } from "primeng/inputswitch";

@Component({
    selector: 'medsurf-design-input-switch',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './switch.input.design.html',
    styleUrls: ['./switch.input.design.scss'],
    standalone: false
})
export class SwitchInputDesign {
  @Input() formField = true;
  @Input({ required: true }) name!: string;
  @Input() inputClass = undefined;
  @Input() label?: string;
  @Input() disabled = false;
  @Input() labelTop = false;
  @Input({ required: true }) model!: boolean;
  @Output() valueChange = new EventEmitter<InputSwitchChangeEvent>();
}
